import { forwardRef, HTMLAttributes } from 'react';
import { cn } from './cn';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
  label?: string;
}

export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(function Spinner(
  { size = 'md', label = 'Loading', className, ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      data-tss-ui=""
      data-size={size}
      className={cn('tss-spinner', className)}
      role="status"
      aria-label={label}
      {...rest}
    >
      <span className="tss-spinner__ring" aria-hidden="true" />
    </div>
  );
});
